<template>
  <div class="twitter-header">
    <nav class="navbar">
      <div class="container bottom-line">
        <div class="nav navbar-nav make-left">
          <span class="navbar-brand">Search @ Twitter</span>
        </div>
        <div class="nav navbar-nav make-right">
          <span class="navbar-brand" style="font-size: 15px;">Auto refresh in {{time}} seconds</span>
        </div>
      </div>
    </nav>

    <div class="container">
      <div style="text-align: center;margin-bottom: 35px;">
        <form v-on:submit.prevent="">
          <input type="text" v-model="searchKey" class="form-control" id="usr">
          <button v-on:click="assignKey()" class="btn btn-primary search-button">
            <router-link to="/search">SEARCH</router-link>
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import TwitterContent from "./TwitterContent.vue";
import DataService from "../services/DataService";

export default {
  name: "twitter-header",
  components: { TwitterContent },
  props: {
    msg: {
      type: String
    }
  },
  data() {
    return {
      time: 30,
      searchKey: "",
    };
  },
  mounted: function() {
    this.$root.$on("countReset", text => {
      this.time = text == true ? 30 : this.time;
    });
    this.$root.$on("startCounting", result => {
      if(result == true){
        this.startCounting();
      }else{
        this.time = 30;
      }
    });
  },
  methods: {
    assignKey: function() {
      DataService.get(this.searchKey).then(response => {
        this.$root.$emit("searchData",response);
      }).catch(error => {
        console.error(error);
      });
    },
    startCounting: function() {
      setInterval(() => {
        this.time = this.time - 1;
      }, 1000);  
    }
  }
};
</script>

<style>
span {
  color: #1da1f2;
}

.make-left {
  float: left;
}

.make-right {
  float: right;
}
</style>

<style scoped>
.search-button > a {
  text-decoration: none !important;
  color: white !important;
}

.bottom-line {
  border-bottom: 2px solid #1da1f2;
}

#usr {
  width: 50% !important;
  display: inline;
}
</style>



// WEBPACK FOOTER //
// src/components/TwitterHeader.vue